:host {
  display: block;
}

.with-sidebar {
  overflow: hidden;
}

.with-sidebar > * {
  display: flex;
  flex-wrap: wrap;
  margin: calc(var(--space) / 2 * -1);
}

.with-sidebar > * > * {
  margin: calc(var(--space) / 2);
  flex-grow: 1;
  flex-basis: var(--sidebar-width);
}

.with-sidebar > * > :last-child {
  flex-basis: 0;
  flex-grow: 999;
  min-width: calc(var(--content-min) - var(--space));
}
